import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
// Serices
import { ClientsService } from '../../../../services/clients.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
// Models
import { EventType, EventSubscriptionType, EventModel } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
// Components
import { ActivityListComponent } from './modal/activity-list/activity-list.component';

@Component({
    selector: 'app-clients',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit, OnDestroy {
    data: any;
    dtConfig = {
        config: {
            base: this.clientService,
            api: 'datatable',
            rowsPerPage: 15,
            order: [[2, 'desc']],
			params: {
				key: ''
			}
        },
        columns: [
            {
                title: 'ID',
                field: 'mac'
            },
            {
                title: 'Router',
                field: 'box'
            },
            {
                title: 'Email',
                field: 'email'
            },
            {
                title: 'Tel',
                field: 'phone'
            },
            {
                title: 'Device',
                field: 'user_agent'
            }
        ],
        actions: [
            {
                display: 'Actividad',
                icon: 'fa-eye',
                event: 'client.activity',
                conditionality: 'true'
            }
        ]
    };

    bc$;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private clientService: ClientsService,
        private broadcast: BroadcastService,
        private nrModal: NRModalService
    ) { }

    ngOnDestroy(): void {
        if (this.bc$) {
            this.bc$();
        }
    }

    ngOnInit(): void {
        this.bc$ = this.broadcast.on(EventSubscriptionType.TYPE, EventType.MODAL, (event: EventModel) => {
            const props = this.prepareProps(event);
            this.nrModal.open(props);
        });
    }

    prepareProps(event: EventModel): any {
        const props: DynamicHostModel = new DynamicHostModel;
        props.instantiated = false;
        props.modalModel = {
            component: null,
            componentFactoryResolver: this.componentFactoryResolver,
            data: event.data.item
        };

        switch (event.name) {
            case 'client.activity':
                props.modalModel.component = ActivityListComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Actividad del usuario'
                };
                break;
        }

        return props;
    }

}
